// 驾驶舱
import request from '@/utils/request'

// 项目中心统计
export function projectCentre(data) {
  return request({
    url: '/Cockpit/projectCentre',
    method: 'post',
    data
  })
}

// 业务中心统计
export function businessCentre(data) {
  return request({
    url: '/Cockpit/businessCentre',
    method: 'post',
    data
  })
}

// 内部管理
export function innerManagement(data) {
  return request({
    url: '/Cockpit/innerManagement',
    method: 'post',
    data
  })
}

// 新增内部管理数据
export function saveInnerManagement(data) {
  return request({
    url: '/Cockpit/saveInnerManagement',
    method: 'post',
    data
  })
}

// 项目汇总
export function projectSummary(data) {
  return request({
    url: '/Cockpit/projectSummary',
    method: 'post',
    data
  })
}

// 业务中心
export function businessCenter(data) {
  return request({
    url: '/Cockpit/businessCenter',
    method: 'post',
    data
  })
}

// 项目经理-我的项目统计
export function projectManager(data) {
  return request({
    url: '/Cockpit/projectManager',
    method: 'post',
    data
  })
}

// 商务经理-我的线索统计
export function businessManager(data) {
  return request({
    url: '/Cockpit/businessManager',
    method: 'post',
    data
  })
}


